import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ICON_HEADER, ROUTES_SIDE_BAR } from 'src/app/shared/data/data';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  @Output() action = new EventEmitter<boolean>();
  linksNavs = ICON_HEADER;
  showMenuDetails: boolean = true;
  activeIconMenu: number = 0;
  sitePath: string = location.href;
  userRole: string = '';

  constructor(
    private router: Router,
    private readonly authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.pathRefs()
    this.userRole = this.authService.readTypeUser();
    this.linksNavs = this.linksNavs.filter(link => link.role.includes(this.userRole));
  }

  toggleMenu(value: boolean) {
    this.showMenuDetails = !this.showMenuDetails
    this.action.emit(value);
  }

  showMore(item: number) {
    this.activeIconMenu = item;
    const dashboardRoute = '/home/dashboard';
    const routersMap = ROUTES_SIDE_BAR;
    this.router.navigateByUrl(routersMap[item] ?? dashboardRoute)
  }

  pathRefs() {

    const activeIconMap: any = {
      '/dashboard': 0,
      'userdash': 1,
      '/oport': 2,
      '/noti': 3,
      '/challenges': 4,
      '/free-companies': 5,
      '/reports/reports': 6,
      '/reports/logs': 7,
    };

    const currentKey = Object.keys(activeIconMap).find((key) => this.sitePath.includes(key)) ?? 0;
    if (typeof currentKey != undefined) {
      this.activeIconMenu = activeIconMap[currentKey];
    }
  }

}
